import { createContext } from "react";

const EntityContext = createContext();

export default EntityContext;
